import type { ISuggestionsQueryArgs } from '@bridebook/toolbox/src/search-suppliers/suggestions/suggestions';
import { useQuery } from '@tanstack/react-query';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { fetchy } from '@bridebook/web/lib/fetchy';
import { toMillis } from '@bridebook/web/lib/utils';

const SUPPLIER_SUGGESTIONS_QUERY_CACHE_TIME = toMillis(15, 'min');

/**
 * Returns a list of suggested suppliers based on search term
 */
export const useSupplierSuggestions = ({
  searchTerm,
  type,
  size,
  lockCategory,
}: ISuggestionsQueryArgs) => {
  const countryCode = useMarket().country;

  const { data } = useQuery(
    ['supplier-suggestions', searchTerm, countryCode, type],
    () =>
      fetchy().post('/api/search/suggestions', null, {
        searchTerm,
        type,
        size,
        lockCategory,
        countryCode,
      }),
    {
      enabled: !!searchTerm,
      keepPreviousData: true,
      cacheTime: SUPPLIER_SUGGESTIONS_QUERY_CACHE_TIME,
      staleTime: SUPPLIER_SUGGESTIONS_QUERY_CACHE_TIME,
    },
  );

  return {
    supplierSuggestions: data,
  };
};
